<template>
  <div class="facility-area-box">
    <span class="box-title">避難所</span>
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0 shelter-table"
      locale="ja-jp"
      hide-default-footer
      hide-default-header
      item-key="key"
      no-data-text=""
      :items-per-page="500"
    >
      <template v-slot:[`item.eva_municip_code`]="{ item }">
        <v-select
          :items="municipalities"
          v-model="item.eva_municip_code"
          v-bind="$formControlProps(readOnly)"
          label="避難先市町村"
          :placeholder="config.PLACEHOLDER_SELECT"
          @change="changeMunicipality(item)"
        ></v-select>
      </template>
      <template v-slot:[`item.fa_id`]="{ item }">
        <v-select
          :items="shelterForEdit[item.key]"
          v-model="item.fa_id"
          v-bind="$formControlProps(readOnly)"
          label="避難所"
          :placeholder="config.PLACEHOLDER_SELECT"
          :error-messages="errorArea(item)"
          item-text="fa_name"
          item-value="fa_id"
        ></v-select>
      </template>
      <template v-slot:[`item.actions`]>
        <v-btn class="mx-2" color="primary" v-if="!readOnly" @click="addItem"
          >追加</v-btn
        >
      </template>
    </v-data-table>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
import maxBy from "lodash/maxBy";
import config from "@/js/const";

export default {
  name: "ShelterInfo",
  data: () => ({
    config: config,
    items: [],
    shelterForEdit: []
  }),
  props: {
    shelterInfo: {
      type: Array,
      default: () => []
    },
    editedShelterInfo: {
      type: Array,
      default: () => []
    },
    municipalities: {
      type: Array,
      default: () => []
    },
    facilities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean
    },
    autonomyCd: {
      type: String
    }
  },
  watch: {
    items: {
      handler: function(newItems) {
        this.$emit("update:editedShelterInfo", newItems);
      },
      deep: true
    },
    autonomyCd: "initialize"
  },
  mounted() {
    this.initialize();
  },
  computed: {
    headers() {
      return [
        {
          text: "避難先市町村",
          value: "eva_municip_code",
          sortable: false
        },
        {
          text: "避難所",
          value: "fa_id",
          sortable: false
        },
        {
          text: "操作",
          value: "actions",
          sortable: false
        }
      ];
    }
  },
  methods: {
    initialize() {
      if (this.editedShelterInfo.length == 0) {
        this.items = cloneDeep(this.shelterInfo);
      } else {
        this.items = cloneDeep(this.editedShelterInfo);
      }
      // keyが存在しない場合は追加
      this.items.forEach((item, index) => {
        if (!item.key) {
          item.key = index + 1;
        }
      });
      this.items.forEach(item => {
        this.changeMunicipality(item, false);
      });
    },
    addItem() {
      const maxItem = maxBy(this.items, "key");
      this.items.push({
        key: maxItem.key + 1,
        eva_municip_code: "",
        fa_id: "",
        flagship_fa_flg: "0"
      });
    },
    // 市町村が変更されたとき
    changeMunicipality(item) {
      //市町村が空の時は避難所の選択をクリア
      if (item.eva_municip_code === "" || item.eva_municip_code === undefined) {
        item.fa_id = "";
      }
      //避難所リストボックス設定
      if (this.facilities.length > 0) {
        //選択市町村・避難所のみに絞込み
        this.shelterForEdit[item.key] = this.facilities.filter(
          facility => facility.ju_municip_code === item.eva_municip_code
        );
      }
    },
    errorArea(item, items = this.items) {
      // 避難所の重複チェック
      if (!item.fa_id) {
        return "";
      }
      const hasItem = items.some(data => {
        return item.key !== data.key && item.fa_id === data.fa_id;
      });
      if (hasItem) {
        return "重複しています。";
      }
      return "";
    },
    validate() {
      let validate = true;
      this.editedShelterInfo.forEach(item => {
        if (this.errorArea(item, this.editedShelterInfo) !== "") {
          validate = false;
          return false;
        }
      });
      return validate === true;
    }
  }
};
</script>
